// gameengine/gameFacilities.js

/**
 * Processes facility construction progress
 * @param {Array} facilities - Array of base facilities
 * @returns {Array} Updated facilities with construction progress
 */
export const processFacilityConstruction = (facilities) => {
  return facilities.map(facility => {
    if (facility.construction_days_remaining > 0) {
      const daysRemaining = facility.construction_days_remaining - 1;
      return {
        ...facility,
        construction_days_remaining: daysRemaining,
        is_active: daysRemaining === 0
      };
    }
    return facility;
  });
};

/**
 * Checks if a facility will complete on the next day
 * @param {Object} facility - Facility to check
 * @returns {boolean} Whether facility completes next day
 */
export const willCompleteNextDay = (facility) => {
  return facility.construction_days_remaining === 1;
};

/**
 * Gets days until facility completion
 * @param {Object} facility - Facility to check
 * @returns {number} Days remaining
 */
export const getDaysUntilCompletion = (facility) => {
  return facility.construction_days_remaining || 0;
};

/**
 * Gets all active facilities
 * @param {Array} facilities - Array of facilities
 * @returns {Array} Active facilities
 */
export const getActiveFacilities = (facilities) => {
  return facilities.filter(f => 
    (f.is_active === true || f.is_active === 1) && 
    (f.construction_days_remaining === 0 || f.construction_days_remaining === undefined)
  );
};

/**
 * Gets facilities by type
 * @param {Array} facilities - Array of facilities
 * @param {string} type - Facility type to filter
 * @returns {Array} Filtered facilities
 */
export const getFacilitiesByType = (facilities, type) => {
  return facilities.filter(f => f.facility_type === type || f.type === type);
};

/**
 * Checks if a facility is under construction
 * @param {Object} facility - Facility to check
 * @returns {boolean} Whether facility is under construction
 */
export const isUnderConstruction = (facility) => {
  return facility.construction_days_remaining > 0;
};